import React from 'react';
import CommonButton from '../../../common/components/CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import { useMediaQuery } from '../../../common/hooks/useMediaQuery';
import nextGearConvertibleImage from '../../../assets/img/nextGear/next-gear-red-convertible-transparent.png';
import nextGearIcon from '../../../assets/img/nextGear/next-gear-icon.png';
import { NEXT_GEAR_CAPITAL_URL } from '../../constants';

function NextGearWhatIsSection() {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleLearnMoreClick = () => {
    window.open(NEXT_GEAR_CAPITAL_URL);
  };

  const buttonCaption = isMobile
    ? 'Learn more'
    : 'Learn more about how NextGear Capital works';

  const listItems = [
    {
      id: 'item-1',
      label: 'Approved dealers are given a stocking limit they can draw against.',
    },
    {
      id: 'item-2',
      label: 'NextGear Capital pays the auction or vendor directly on the dealer’s behalf.',
    },
    {
      id: 'item-3',
      label:
        'The dealer then repays NextGear Capital within the agreed timeframe (typically up to 150 days), including any fees.',
    },
    {
      id: 'item-4',
      label:
        'Vehicles can be funded from multiple sources, including online and physical auctions, trade purchases, and part exchanges.',
    },
  ];

  return (
    <section className="ng-what-is">
      <div className="ng-what-is__inner">
        <img
          src={nextGearConvertibleImage}
          className="ng-what-is__car"
          alt="NextGear Convertible"
        />
        <div className="ng-what-is__content">
          <h2 className="ng-what-is__title">What is NextGear Capital?</h2>
          <p className="ng-what-is__paragraph">
            NextGear Capital provides stock funding for motor traders. Instead of paying for
            vehicles in full with your own capital at the time of purchase, dealers can fund
            vehicles for a fixed period, helping to manage cash flow. Here’s how it works:
          </p>
          <ul className="ng-what-is__list">
            {listItems.map((item) => (
              <li key={item.id} className="ng-what-is__list-item">
                {item.label}
              </li>
            ))}
          </ul>
          <CommonButton
            label={buttonCaption}
            className="ng-what-is__button"
            variant={CommonButtonVariants.OUTLINED}
            handleClick={handleLearnMoreClick}
          />
          <img src={nextGearIcon} alt="NextGear Icon" className="ng-what-is__icon" />
        </div>
      </div>
    </section>
  );
}

export default NextGearWhatIsSection;
